import React, { useState, useEffect } from 'react';
import { X, Loader2 } from 'lucide-react';
import Select from 'react-select';
import { companiesAPI, contactsAPI, employeesAPI } from '../../../services/api';
import { toast } from 'react-toastify';

const industryOptions = [
  { value: 'IT', label: 'IT' }, { value: 'FINANCE', label: 'Finance' },
  { value: 'HEALTHCARE', label: 'Healthcare' }, { value: 'EDUCATION', label: 'Education' },
  { value: 'MANUFACTURING', label: 'Manufacturing' }, { value: 'RETAIL', label: 'Retail' },
  { value: 'OTHER', label: 'Other' }
];
const leadStatusOptions = [
  { value: 'NEW', label: 'New' }, { value: 'CONTACTED', label: 'Contacted' },
  { value: 'QUALIFIED', label: 'Qualified' }, { value: 'LOST', label: 'Lost' },
  { value: 'WON', label: 'Won' }, { value: 'OTHER', label: 'Other' }
];
const leadSourceOptions = [
  { value: 'WEBSITE', label: 'Website' }, { value: 'REFERRAL', label: 'Referral' },
  { value: 'PARTNER', label: 'Partner' }, { value: 'SOCIAL_MEDIA', label: 'Social Media' },
  { value: 'EMAIL', label: 'Email' }, { value: 'CALL', label: 'Call' }, { value: 'OTHER', label: 'Other' }
];
const relationshipTypeOptions = [
  { value: 'CLIENT', label: 'Client' }, { value: 'PARTNER', label: 'Partner' },
  { value: 'SUPPLIER', label: 'Supplier' }, { value: 'VENDOR', label: 'Vendor' },
  { value: 'DISTRIBUTOR', label: 'Distributor' }, { value: 'RESELLER', label: 'Reseller' },
  { value: 'CONTRACTOR', label: 'Contractor' }, { value: 'CONSULTANT', label: 'Consultant' },
  { value: 'SERVICE_PROVIDER', label: 'Service Provider' }, { value: 'INVESTOR', label: 'Investor' },
  { value: 'MANUFACTURER', label: 'Manufacturer' }, { value: 'OTHER', label: 'Other' }
];
const companyStageOptions = [
  { value: 'STARTUP', label: 'Startup' }, { value: 'SMALL', label: 'Small' },
  { value: 'MEDIUM', label: 'Medium' }, { value: 'LARGE', label: 'Large' },
  { value: 'ENTERPRISE', label: 'Enterprise' }, { value: 'OTHER', label: 'Other' }
];
const legalTypeOptions = [
  { value: 'SOLE_PROPRIETORSHIP', label: 'Sole Proprietorship' },
  { value: 'PARTNERSHIP_FIRM', label: 'Partnership Firm' }, { value: 'LLP', label: 'LLP' },
  { value: 'PRIVATE_LIMITED', label: 'Private Limited' }, { value: 'PUBLIC_LIMITED', label: 'Public Limited' },
  { value: 'OPC', label: 'One Person Company' }, { value: 'JOINT_VENTURE', label: 'Joint Venture' },
  { value: 'NON_PROFIT', label: 'Non-Profit' }, { value: 'GOVERNMENT_ENTITY', label: 'Government Entity' },
  { value: 'OTHER', label: 'Other' }
];
const employeeCountOptions = [
  { value: 'RANGE_1_10', label: '1-10' }, { value: 'RANGE_11_50', label: '11-50' },
  { value: 'RANGE_51_100', label: '51-100' }, { value: 'RANGE_101_250', label: '101-250' },
  { value: 'RANGE_251_500', label: '251-500' }, { value: 'RANGE_501_1000', label: '501-1000' },
  { value: 'RANGE_1001_5000', label: '1001-5000' }, { value: 'RANGE_5001_10000', label: '5001-10000' },
  { value: 'RANGE_10000_PLUS', label: '10,000+' }
];
const annualRevenueOptions = [
  { value: 'BELOW_1M', label: 'Below $1M' }, { value: 'RANGE_1M_5M', label: '$1M - $5M' },
  { value: 'RANGE_5M_10M', label: '$5M - $10M' }, { value: 'RANGE_10M_50M', label: '$10M - $50M' },
  { value: 'RANGE_50M_100M', label: '$50M - $100M' }, { value: 'RANGE_100M_500M', label: '$100M - $500M' },
  { value: 'RANGE_500M_1B', label: '$500M - $1B' }, { value: 'RANGE_1B_5B', label: '$1B - $5B' },
  { value: 'RANGE_5B_10B', label: '$5B - $10B' }, { value: 'ABOVE_10B', label: 'Above $10B' }
];
const taxIdTypeOptions = [
  { value: 'GST', label: 'GST' }, { value: 'EIN', label: 'EIN' }, { value: 'VAT', label: 'VAT' },
  { value: 'TRN', label: 'TRN' }, { value: 'TIN', label: 'TIN' }, { value: 'ABN', label: 'ABN' },
  { value: 'CIF', label: 'CIF' }, { value: 'CNPJ', label: 'CNPJ' }, { value: 'TVA', label: 'TVA' },
  { value: 'IVA', label: 'IVA' }, { value: 'BTW', label: 'BTW' }, { value: 'CUIT', label: 'CUIT' },
  { value: 'RFC', label: 'RFC' }, { value: 'RUC', label: 'RUC' }, { value: 'NIT', label: 'NIT' },
  { value: 'CPF', label: 'CPF' }, { value: 'RIF', label: 'RIF' }, { value: 'OTHER', label: 'Other' }
];
const paymentTermsOptions = [
  { value: 'NET15', label: 'Net 15' }, { value: 'NET30', label: 'Net 30' }, { value: 'NET45', label: 'Net 45' },
  { value: 'NET60', label: 'Net 60' }, { value: 'NET90', label: 'Net 90' }, { value: 'COD', label: 'COD' },
  { value: 'PREPAID', label: 'Prepaid' }, { value: 'LC', label: 'LC' },
  { value: 'PAYMENT_ON_RECEIPT', label: 'Payment on Receipt' }, { value: 'MONTHLY', label: 'Monthly' },
  { value: 'QUARTERLY', label: 'Quarterly' }, { value: 'ANNUAL', label: 'Annual' }, { value: 'OTHER', label: 'Other' }
];
const currencyOptions = [
  { value: 'INR', label: 'INR' }, { value: 'USD', label: 'USD' }, { value: 'EUR', label: 'EUR' },
  { value: 'GBP', label: 'GBP' }, { value: 'JPY', label: 'JPY' }, { value: 'CNY', label: 'CNY' },
  { value: 'CAD', label: 'CAD' }, { value: 'AUD', label: 'AUD' }, { value: 'CHF', label: 'CHF' },
  { value: 'SEK', label: 'SEK' }, { value: 'NOK', label: 'NOK' }, { value: 'DKK', label: 'DKK' },
  { value: 'SGD', label: 'SGD' }, { value: 'HKD', label: 'HKD' }, { value: 'NZD', label: 'NZD' },
  { value: 'ZAR', label: 'ZAR' }, { value: 'BRL', label: 'BRL' }, { value: 'MXN', label: 'MXN' },
  { value: 'AED', label: 'AED' }, { value: 'SAR', label: 'SAR' }, { value: 'KRW', label: 'KRW' },
  { value: 'THB', label: 'THB' }, { value: 'MYR', label: 'MYR' }, { value: 'PHP', label: 'PHP' },
  { value: 'IDR', label: 'IDR' }, { value: 'VND', label: 'VND' }, { value: 'EGP', label: 'EGP' },
  { value: 'NGN', label: 'NGN' }, { value: 'KES', label: 'KES' }, { value: 'OTHER', label: 'Other' }
];

const findOption = (options, value) => options.find(o => o.value === value) || null;

// ✅ Helper: get nested value from form using dot-path e.g. "billingAddress.city"
const getNestedValue = (obj, path) => {
  return path.split('.').reduce((acc, key) => acc?.[key], obj) ?? '';
};

// ✅ Helper: set nested value immutably using dot-path
const setNestedValue = (obj, path, value) => {
  const keys = path.split('.');
  const updated = { ...obj };
  let ref = updated;
  for (let i = 0; i < keys.length - 1; i++) {
    ref[keys[i]] = { ...(ref[keys[i]] || {}) };
    ref = ref[keys[i]];
  }
  ref[keys[keys.length - 1]] = value;
  return updated;
};

const CompanyEditDrawer = ({ company, onClose, onSave }) => {
  const [loading, setLoading] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [contactsLoading, setContactsLoading] = useState(false);
  const [employeesLoading, setEmployeesLoading] = useState(false);
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});

  // Fetch contacts and employees on mount
  useEffect(() => {
    const fetchContacts = async () => {
      setContactsLoading(true);
      try {
        const response = await contactsAPI.getAllContacts();
        const formatted = (response.data || []).map(c => ({
          value: c.id,
          label: `${c.firstName} ${c.lastName}`,
          id: c.id
        }));
        setContacts(formatted);
      } catch (error) {
        console.error('Failed to fetch contacts:', error);
      } finally {
        setContactsLoading(false);
      }
    };
    
    const fetchEmployees = async () => {
      setEmployeesLoading(true);
      try {
        const response = await employeesAPI.getAllEmployees();
        const empList = Array.isArray(response.data) ? response.data : response.data?.data || [];
        const formatted = empList.map(emp => ({
          value: emp.id,
          label: emp.name || `${emp.firstName || ''} ${emp.lastName || ''}`.trim() || emp.email || emp.id,
          id: emp.id
        }));
        setEmployees(formatted);
      } catch (error) {
        console.error('Failed to fetch employees:', error);
      } finally {
        setEmployeesLoading(false);
      }
    };
    
    fetchContacts();
    fetchEmployees();
  }, []);

  // Auto-fill form when company changes
  useEffect(() => {
    if (!company) return;
    const selectedContacts = (company.contact_ids || []).map(id => {
      const contact = contacts.find(c => c.id === id);
      return contact || { value: id, label: `Contact ${id}`, id };
    });
    const selectedOwner = company.contactOwner ? employees.find(e => e.value === company.contactOwner) : null;
    setForm({
      companyName: company.companyName || '',
      websiteUrl: company.websiteUrl || '',
      linkedInUrl: company.linkedInUrl || '',
      primaryContact: company.primaryContact || '',
      contact_ids: selectedContacts,
      jobTitle: company.jobTitle || '',
      email: company.email || '',
      phone: company.phone || '',
      contactOwner: selectedOwner,
      industry: findOption(industryOptions, company.industry),
      leadStatus: findOption(leadStatusOptions, company.leadStatus),
      leadSource: findOption(leadSourceOptions, company.leadSource),
      relationshipType: findOption(relationshipTypeOptions, company.relationshipType),
      companyStage: findOption(companyStageOptions, company.companyStage),
      legalType: findOption(legalTypeOptions, company.legalType),
      employeeCount: findOption(employeeCountOptions, company.employeeCount),
      annualRevenue: findOption(annualRevenueOptions, company.annualRevenue),
      doNotCall: company.doNotCall || false,
      doNotEmail: company.doNotEmail || false,
      billingAddress: company.billingAddress || {},
      shippingAddress: company.shippingAddress || {},
      sameAsBilling: company.sameAsBilling || false,
      taxIdType: findOption(taxIdTypeOptions, company.taxIdType),
      taxIdNumber: company.taxIdNumber || '',
      paymentTerms: findOption(paymentTermsOptions, company.paymentTerms),
      currency: findOption(currencyOptions, company.currency),
      notes: company.notes || '',
    });
  }, [company, contacts, employees]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === 'checkbox' ? checked : value;
    if (name.includes('.')) {
      setForm(prev => setNestedValue(prev, name, newValue));
    } else {
      setForm(prev => ({ ...prev, [name]: newValue }));
    }
    if (errors[name]) setErrors(prev => { const n = {...prev}; delete n[name]; return n; });
  };

  const handleSelect = (name, value) => {
    setForm(prev => ({ ...prev, [name]: value }));
  };

  // ✅ Copy billing address to shipping address
  const handleSameAsBilling = (checked) => {
    setForm(prev => ({
      ...prev,
      sameAsBilling: checked,
      shippingAddress: checked ? { ...(prev.billingAddress || {}) } : prev.shippingAddress,
    }));
  };

  const handleSubmit = async () => {
    const errs = {};
    if (!form.companyName?.trim()) errs.companyName = 'Company name is required';
    
    // Email validation
    if (form.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      errs.email = 'Please enter a valid email address';
    }
    
    // Phone validation
    if (form.phone) {
      const phoneDigits = String(form.phone).replace(/\D/g, '');
      if (phoneDigits.length < 10) {
        errs.phone = 'Please enter a valid 10-digit phone number';
      }
    }

    setErrors(errs);
    if (Object.keys(errs).length > 0) {
      toast.error('Please fix the errors before saving');
      return;
    }
    setLoading(true);
    try {
      const payload = {
        ...form,
        industry: form.industry?.value || null,
        leadStatus: form.leadStatus?.value || null,
        leadSource: form.leadSource?.value || null,
        relationshipType: form.relationshipType?.value || null,
        companyStage: form.companyStage?.value || null,
        legalType: form.legalType?.value || null,
        employeeCount: form.employeeCount?.value || null,
        annualRevenue: form.annualRevenue?.value || null,
        contactOwner: form.contactOwner?.value || null,
        taxIdType: form.taxIdType?.value || null,
        paymentTerms: form.paymentTerms?.value || null,
        currency: form.currency?.value || null,
      };
      await companiesAPI.updateCompany(company.id, payload);
      toast.success('Company updated successfully');
      onSave({ ...company, ...payload });
    } catch (error) {
      console.error('Error updating company:', error);
      toast.error(error.response?.data?.message || 'Failed to update company');
    } finally {
      setLoading(false);
    }
  };

  if (!company) return null;

  const Field = ({ label, name, type = 'text', placeholder }) => (
    <div>
      <label className="block text-xs font-medium text-gray-600 mb-1">{label}</label>
      <input type={type} name={name} value={getNestedValue(form, name)} onChange={handleChange}
        placeholder={placeholder || label}
        className={`w-full px-3 py-2 text-sm border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors ${errors[name] ? 'border-red-500 bg-red-50' : 'border-gray-300'}`} />
      {errors[name] && <p className="text-red-600 text-[10px] mt-1">⚠ {errors[name]}</p>}
    </div>
  );

  const SelectField = ({ label, name, options }) => (
    <div>
      <label className="block text-xs font-medium text-gray-600 mb-1">{label}</label>
      <Select options={options} value={form[name]} onChange={v => handleSelect(name, v)}
        isClearable placeholder={`Select ${label}`}
        classNamePrefix="react-select"
        styles={{ control: (b) => ({ ...b, fontSize: '14px', minHeight: '38px' }) }} />
    </div>
  );

  return (
    <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black bg-opacity-30 z-40" onClick={onClose} />

      {/* Drawer */}
      <div className="fixed top-0 right-0 h-full w-full max-w-md bg-white shadow-2xl z-50 flex flex-col animate-slide-in">
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b bg-gray-50">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-blue-500 rounded-lg flex items-center justify-center text-white text-sm font-bold">
              {company.companyName?.charAt(0)}
            </div>
            <div>
              <h2 className="text-sm font-semibold text-gray-900">Edit Company</h2>
              <p className="text-xs text-gray-500">{company.companyName}</p>
            </div>
          </div>
          <button onClick={onClose} className="p-1.5 rounded-md hover:bg-gray-200 text-gray-500 transition-colors">
            <X size={18} />
          </button>
        </div>

        {/* Body */}
        <div className="flex-1 overflow-y-auto px-5 py-4 space-y-5">
          {/* Basic Info */}
          <section>
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Basic Info</p>
            <div className="space-y-3">
              <Field label="Company Name *" name="companyName" />
              <Field label="Website" name="websiteUrl" placeholder="example.com" />
              <Field label="LinkedIn URL" name="linkedInUrl" placeholder="linkedin.com/company/..." />
            </div>
          </section>

          {/* Classification */}
          <section>
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Classification</p>
            <div className="space-y-3">
              <SelectField label="Industry" name="industry" options={industryOptions} />
              <SelectField label="Relationship Type" name="relationshipType" options={relationshipTypeOptions} />
              <SelectField label="Company Stage" name="companyStage" options={companyStageOptions} />
              <SelectField label="Legal Type" name="legalType" options={legalTypeOptions} />
              <SelectField label="Employee Count" name="employeeCount" options={employeeCountOptions} />
              <SelectField label="Annual Revenue" name="annualRevenue" options={annualRevenueOptions} />
            </div>
          </section>

          {/* Lead Info */}
          <section>
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Lead Info</p>
            <div className="space-y-3">
              <SelectField label="Lead Status" name="leadStatus" options={leadStatusOptions} />
              <SelectField label="Lead Source" name="leadSource" options={leadSourceOptions} />
            </div>
          </section>

          {/* Contact */}
          <section>
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Contact</p>
            <div className="space-y-3">
              <Field label="Primary Contact" name="primaryContact" />
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Associated Contacts</label>
                <Select isMulti options={contacts} value={form.contact_ids}
                  onChange={(selected) => setForm(prev => ({ ...prev, contact_ids: selected || [] }))}
                  isLoading={contactsLoading} placeholder="Select contacts"
                  classNamePrefix="react-select"
                  styles={{ control: (b) => ({ ...b, fontSize: '14px', minHeight: '38px' }) }} />
              </div>
              <Field label="Job Title" name="jobTitle" />
              <Field label="Email" name="email" type="email" />
              <Field label="Phone" name="phone" type="tel" />
              <div className="flex items-center gap-6 pt-1">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" name="doNotCall" checked={form.doNotCall || false} onChange={handleChange}
                    className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                  <span className="text-xs font-medium text-gray-600">Do Not Call</span>
                </label>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" name="doNotEmail" checked={form.doNotEmail || false} onChange={handleChange}
                    className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                  <span className="text-xs font-medium text-gray-600">Do Not Email</span>
                </label>
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1">Assigned To</label>
                <Select options={employees} value={form.contactOwner} onChange={v => handleSelect('contactOwner', v)}
                  isClearable isLoading={employeesLoading} placeholder="Select employee"
                  classNamePrefix="react-select"
                  styles={{ control: (b) => ({ ...b, fontSize: '14px', minHeight: '38px' }) }} />
              </div>
            </div>
          </section>

          {/* Address */}
          <section>
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Billing Address</p>
            <div className="space-y-3">
              <Field label="Street Line 1" name="billingAddress.streetLine1" />
              <Field label="Street Line 2" name="billingAddress.streetLine2" />
              <Field label="City" name="billingAddress.city" />
              <Field label="State" name="billingAddress.state" />
              <Field label="Country" name="billingAddress.country" />
              <Field label="Zipcode" name="billingAddress.zipcode" />
            </div>

            <label className="flex items-center gap-2 mt-3 cursor-pointer">
              <input type="checkbox" checked={form.sameAsBilling || false}
                onChange={(e) => handleSameAsBilling(e.target.checked)}
                className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
              <span className="text-xs font-medium text-gray-600">Shipping address same as billing</span>
            </label>

            {!form.sameAsBilling && (
              <div className="space-y-3 mt-3">
                <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-1">Shipping Address</p>
                <Field label="Street Line 1" name="shippingAddress.streetLine1" />
                <Field label="Street Line 2" name="shippingAddress.streetLine2" />
                <Field label="City" name="shippingAddress.city" />
                <Field label="State" name="shippingAddress.state" />
                <Field label="Country" name="shippingAddress.country" />
                <Field label="Zipcode" name="shippingAddress.zipcode" />
              </div>
            )}
          </section>

          {/* Financial */}
          <section>
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Financial</p>
            <div className="space-y-3">
              <SelectField label="Tax ID Type" name="taxIdType" options={taxIdTypeOptions} />
              <Field label="Tax ID Number" name="taxIdNumber" />
              <SelectField label="Payment Terms" name="paymentTerms" options={paymentTermsOptions} />
              <SelectField label="Currency" name="currency" options={currencyOptions} />
            </div>
          </section>

          {/* Notes */}
          <section>
            <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider mb-3">Notes</p>
            <textarea name="notes" value={form.notes || ''} onChange={handleChange} rows={4}
              placeholder="Add notes about this company..."
              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors" />
          </section>
        </div>

        {/* Footer */}
        <div className="px-5 py-4 border-t bg-gray-50 flex gap-3 justify-end">
          <button onClick={onClose} disabled={loading}
            className="px-4 py-2 text-sm border border-gray-300 rounded-md hover:bg-gray-100 transition-colors disabled:opacity-60">
            Cancel
          </button>
          <button onClick={handleSubmit} disabled={loading}
            className="flex items-center gap-2 px-4 py-2 text-sm bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors disabled:opacity-60">
            {loading && <Loader2 size={14} className="animate-spin" />}
            {loading ? 'Saving...' : 'Save Changes'}
          </button>
        </div>
      </div>
    </>
  );
};

export default CompanyEditDrawer;